import { useI18n } from 'builder/hooks/useI18n'
import { usePostRedirectUrl } from './hooks/useGetRedirectUrl'
import { TRANSLATION } from './utils'
import LearningHubIcon from './assets/LearningHubProfileIcon.svg'
import { LearningHubCustomLink } from './styles'

export const LearningHubLink = () => {
  const { i18n } = useI18n()
  const { mutateAsync } = usePostRedirectUrl()

  const handleRedirect = async () => {
    const response = await mutateAsync({})
    return window.open(response.redirect_url, '_blank')
  }

  return (
    <LearningHubCustomLink to="#" onClick={handleRedirect} data-testid="learning-hub-link">
      <img src={LearningHubIcon} width="32px" height="32px" alt="Learning Hub Icon" />
      {i18n.t(`${TRANSLATION}.title`)}
    </LearningHubCustomLink>
  )
}
